import { format } from 'date-fns';

export const formatDate = (date: string, dateFormat?: string): string => {
  return format(Date.parse(date), dateFormat || 'dd/MM/yyyy');
};
